import { TRetrieveCheckoutSession } from '@commenda/types/src/billing/types';
import { fetcher } from '@commenda/utils';

export async function getCheckoutSession(
  checkoutSessionId: string
): Promise<{ data: TRetrieveCheckoutSession } | null> {
  try {
    const res = await fetcher(
      `billing-new/checkout/session?checkoutSessionId=${checkoutSessionId}`,
      {
        method: 'GET',
      }
    );

    if (!res.ok) {
      return null;
    }

    const data: TRetrieveCheckoutSession =
      (await res.json()) as TRetrieveCheckoutSession;

    return { data };
  } catch (err) {
    console.error(err);
    return null;
  }
}
